import {STEP3_INNER} from '@/js/common/constants';
export default {
  data() {
    return {
      STEPS: STEP3_INNER,
    };
  },
};
